import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function Signals() {
  const [signals, setSignals] = useState([]);
  useEffect(() => {
    const load = () => api.get("/signals?limit=100").then((r) => setSignals(r.data)).catch(() => {});
    load();
    const i = setInterval(load, 15000);
    return () => clearInterval(i);
  }, []);

  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-4" data-testid="signals-page">
      <div>
        <div className="text-[10px] uppercase tracking-widest text-zinc-500">Detections</div>
        <h1 className="text-xl sm:text-2xl font-medium tracking-tight">Signals</h1>
      </div>

      {/* Desktop table */}
      <div className="hidden md:block border border-white/10 bg-[#121214] rounded-sm overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-[10px] uppercase tracking-widest text-zinc-500 border-b border-white/10">
              <th className="text-left py-2 px-4">Detected</th>
              <th className="text-left">Pair</th>
              <th className="text-left">Side</th>
              <th className="text-right">Entry</th>
              <th className="text-right">SL</th>
              <th className="text-right">TP</th>
              <th className="text-left">Candle C</th>
              <th className="text-right pr-4">Executed</th>
            </tr>
          </thead>
          <tbody className="font-mono">
            {signals.length === 0 && (
              <tr><td colSpan={8} className="text-center text-zinc-500 py-8">No signals detected yet</td></tr>
            )}
            {signals.map((s) => (
              <tr key={s.id} className="border-b border-white/5 hover:bg-white/[0.02]" data-testid={`signal-row-${s.id}`}>
                <td className="py-2 px-4 text-xs text-zinc-400">{s.detected_at?.slice(11, 19)}</td>
                <td>{s.pair}</td>
                <td className={s.side === "BUY" ? "text-teal-400" : "text-rose-400"}>{s.side}</td>
                <td className="text-right tabular-nums">{s.entry_price?.toFixed(5)}</td>
                <td className="text-right tabular-nums">{s.stop_loss?.toFixed(5)}</td>
                <td className="text-right tabular-nums">{s.take_profit?.toFixed(5)}</td>
                <td className="text-xs text-zinc-500">{s.entry_candle_time?.slice(11, 16)}</td>
                <td className="text-right pr-4">{s.executed ? <span className="text-teal-400">{s.executions}×</span> : <span className="text-zinc-500">—</span>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile card list */}
      <div className="md:hidden border border-white/10 bg-[#121214] rounded-sm divide-y divide-white/5">
        {signals.length === 0 && (
          <div className="text-center text-zinc-500 py-8 text-sm">No signals detected yet</div>
        )}
        {signals.map((s) => (
          <div key={s.id} className="p-3 font-mono" data-testid={`signal-row-${s.id}`}>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span className={`text-sm font-medium ${s.side === "BUY" ? "text-teal-400" : "text-rose-400"}`}>{s.side}</span>
                <span className="text-sm text-zinc-100">{s.pair}</span>
              </div>
              <div className="text-[11px]">
                {s.executed
                  ? <span className="text-teal-400">{s.executions}× fired</span>
                  : <span className="text-zinc-500">not executed</span>}
              </div>
            </div>
            <div className="grid grid-cols-3 gap-2 mt-2 text-[11px]">
              <div>
                <div className="text-[9px] uppercase text-zinc-600 tracking-widest">Entry</div>
                <div className="text-zinc-200 tabular-nums">{s.entry_price?.toFixed(5)}</div>
              </div>
              <div>
                <div className="text-[9px] uppercase text-zinc-600 tracking-widest">SL</div>
                <div className="text-rose-300 tabular-nums">{s.stop_loss?.toFixed(5)}</div>
              </div>
              <div>
                <div className="text-[9px] uppercase text-zinc-600 tracking-widest">TP</div>
                <div className="text-teal-300 tabular-nums">{s.take_profit?.toFixed(5)}</div>
              </div>
            </div>
            <div className="text-[10px] text-zinc-600 mt-2">{s.detected_at?.slice(11, 19)} UTC · Candle {s.entry_candle_time?.slice(11, 16)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
